(function () {
  'use strict';

  var scrollRoot = null;
  var drawer = null;

  function getDrawer() {
    return document.querySelector('menu-drawer.viva-nav-drawer');
  }

  function getPrimaryMenu() {
    if (!drawer) return null;
    return (
      drawer.querySelector('#VivaDrawerPrimaryNav .drawer__menu') ||
      drawer.querySelector('nav.menu-drawer__main .drawer__menu')
    );
  }

  function getScrollRoot() {
    var rootDrawer = getDrawer();
    if (!rootDrawer) return null;
    var details = rootDrawer.querySelector('details.menu-drawer_details[open]');
    if (!details) return null;
    return (
      details.querySelector('.viva-nav-drawer__panel') ||
      details.querySelector('nav.menu-drawer__main') ||
      details.querySelector('.menu-drawer__main')
    );
  }

  function clearScrollMarkers(root) {
    if (!root) return;
    root.querySelectorAll('[data-viva-drawer-scroll]').forEach(function (el) {
      el.removeAttribute('data-viva-drawer-scroll');
    });
  }

  function syncScrollRoot() {
    var next = getScrollRoot();
    if (next === scrollRoot) return;

    if (scrollRoot) {
      scrollRoot.removeAttribute('data-viva-drawer-scroll');
    }

    scrollRoot = next;

    if (scrollRoot) {
      var details = scrollRoot.closest('details.menu-drawer_details');
      if (details) clearScrollMarkers(details);
      scrollRoot.setAttribute('data-viva-drawer-scroll', 'true');
    }
  }

  function isTopLevelDetails(details) {
    var menu = getPrimaryMenu();
    return Boolean(menu && details.parentElement === menu);
  }

  function syncDrilldown() {
    var menu = getPrimaryMenu();
    if (!menu) return;

    var openDetails = menu.querySelector(':scope > details.menu-drawer_details[open]');
    menu.classList.toggle('viva-drawer-menu--drilldown', Boolean(openDetails));

    if (!openDetails) return;

    var backRow = openDetails.querySelector('.menu_drawer__close-container--back-only');
    var backBtn = openDetails.querySelector('.menu-drawer__close-button');
    if (!backRow || !backBtn) return;

    var label = backBtn.getAttribute('aria-label') || '';
    var title = label.replace(/^Retour\s*:\s*/i, '').trim();
    var titleEl = backRow.querySelector('.viva-drawer-back-title');

    if (!title) {
      if (titleEl) titleEl.remove();
      return;
    }

    if (!titleEl) {
      titleEl = document.createElement('span');
      titleEl.className = 'viva-drawer-back-title';
      backRow.appendChild(titleEl);
    }

    titleEl.textContent = title;
  }

  function onMenuToggle(e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('details.menu-drawer_details')) return;

    if (target.hasAttribute('open') && isTopLevelDetails(target)) {
      var menu = getPrimaryMenu();
      if (menu) {
        menu.querySelectorAll(':scope > details.menu-drawer_details[open]').forEach(function (details) {
          if (details === target) return;
          details.classList.remove('menu-opening');
          details.removeAttribute('open');
        });
      }
    }

    syncDrilldown();
    syncScrollRoot();
  }

  function watchDrawer() {
    drawer = getDrawer();
    if (!drawer) return;

    var rootDetails = drawer.querySelector('details.menu-drawer_details');
    if (!rootDetails) return;

    rootDetails.addEventListener('toggle', syncScrollRoot);
    drawer.addEventListener('toggle', onMenuToggle, true);

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        syncDrilldown();
        syncScrollRoot();
      }).observe(drawer, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        subtree: true,
      });
    }

    syncDrilldown();
    syncScrollRoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('menu-drawer.viva-nav-drawer')) {
      watchDrawer();
    }
  });
})();
